export default __webpack_public_path__ + "static/media/calendar-icon.c11237dd.svg";